
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_6015_2960)"}},[_c('path',{attrs:{"d":"M13.57 1.194H2.874c-.805 0-1.458.654-1.458 1.459v10.694c0 .805.653 1.458 1.458 1.458h10.694c.805 0 1.459-.653 1.459-1.458V2.653c0-.805-.654-1.459-1.459-1.459zM6.277 11.403a.486.486 0 01-.486.486h-.973a.486.486 0 01-.486-.486v-3.89c0-.268.218-.485.486-.485h.973c.268 0 .486.217.486.486v3.889zm2.916 0a.486.486 0 01-.486.486h-.972a.486.486 0 01-.486-.486V4.597c0-.268.217-.486.486-.486h.972c.269 0 .486.218.486.486v6.806zm2.917 0a.486.486 0 01-.486.486h-.972a.486.486 0 01-.487-.486V9.458c0-.268.218-.486.487-.486h.972c.268 0 .486.218.486.486v1.945z","fill":"#282E3E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6015_2960"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.444 .222)","d":"M0 0h15.556v15.556H0z"}})])])])
          )
        }
      }
    